import Author from "../../../../src/components/author.js";
import WriteWithUs from "../../../../src/components/write-with-us.js";
import * as React from 'react';
export default {
  Author,
  WriteWithUs,
  React
};